import { DOCUMENT, inject, Injectable, signal } from '@angular/core'

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private readonly _document = inject(DOCUMENT)
  readonly currentTheme = signal<string>('light')

  setTheme(theme: string) {
    this.currentTheme.set(theme)
    if (theme === 'dark') {
      this._document.documentElement.classList.add('dark-mode')
      localStorage.setItem('darkMode', JSON.stringify(true))
    } else {
      this._document.documentElement.classList.remove('dark-mode')
      localStorage.setItem('darkMode', JSON.stringify(false))
    }
  }
}
